<template>
  <div
    ref="dropdown"
    class="h-12 w-full relative"
    :class="{ 'text-input': !disabled, 'border-zyxel-gray-800': isFocused }"
  >
    <button
      class="flex items-center"
      @click="focusInput"
    >
      <div class="mx-2">
        <div
          class="flag-icon ring-1 ring-zyxel-gray-500"
          :class="[`flag-icon-${modelValue.toLowerCase()}`]"
        />
      </div>
      <span class="flex items-center h-11">{{ showCountry }}</span>
    </button>

    <div
      v-if="isDropdown & !disabled"
      class="autocomplete-results"
    >
      <input
        ref="input"
        v-model="searchText"
        type="text"
        class="h-10 w-full border border-zyxel-gray-500 outline-zyxel-gray-500 bg-white p-2"
        placeholder="Select country"
        aria-label="Select country"
        @input="filterCountries"
      >
      <div class="max-h-60 overflow-y-auto">
        <button
          v-for="country in filteredCountries"
          :key="country.countryShortCode"
          class="autocomplete-item"
          @click="selectCountry(country)"
        >
          <div class="mx-2">
            <div
              class="flag-icon ring-1 ring-zyxel-gray-500"
              :class="[`flag-icon-${country.countryShortCode.toLowerCase()}`]"
            />
          </div>
          {{ country.countryName }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { logger } from '@/utils/logger';

export default {
    props: {
        modelValue: String,
        disabled: Boolean
    },
    data() {
      return {
        countries: [],
        searchText: '',
        showCountry: '',
        filteredCountries: [],
        isFocused: false,
        isDropdown: false,
      };
    },
    watch: {
      modelValue(newVal) {
        this.initializeShowCountry(newVal);
      }
    },
    mounted() {
      const countries_json = require('country-region-data/data.json');
      this.countries = countries_json;

      this.initializeShowCountry(this.modelValue);
      document.addEventListener('click', this.checkIfShouldClose);
    },
    beforeUnmount() {
      document.removeEventListener('click', this.checkIfShouldClose);
    },
    methods: {
      focusInput() {
        this.isFocused = true;
        this.isDropdown = true;
        this.filterCountries();
      },
      checkIfShouldClose(event) {
        if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
          this.isFocused = false;
          this.isDropdown = false;
        }
      },
      filterCountries() {
        if (this.searchText) {
          logger.log((this.countries[0]))
          this.filteredCountries = this.countries.filter(country =>
              country.countryName.toLowerCase().includes(this.searchText.toLowerCase())
          );
        } else {
          this.filteredCountries = this.countries
        }
      },
      selectCountry(country) {
        this.searchText = '';
        this.$emit('update:modelValue', country.countryShortCode);
        this.showCountry = country.countryName;
        this.isDropdown = false;
      },
      initializeShowCountry(code) {
        if (code) {
          const found = this.countries.find(country => country.countryShortCode.toLowerCase() === code.toLowerCase());
          if (found) {
            this.showCountry = found.countryName;
          }
        }
      }
    }
};
</script>

<style>
.autocomplete-results {
    @apply absolute bg-white w-full border;
}

.autocomplete-item {
    @apply p-2 hover:bg-gray-100 cursor-pointer flex items-center;
}

.autocomplete-item flag-icon {
    @apply mr-2;
}
</style>